<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Descargas</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab>Ventas</v-tab>
          <v-tab>Entregas</v-tab>
        </v-tabs>
      </div>
      <div>
        <v-btn color="success" outlined @click="doDownloads" class="mx-2">
          Descargar
        </v-btn>
      </div>
    </v-card>
    <v-card-text v-if="currentTab === 0">
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            multiple
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estructura Comercial"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedStructure"
            return-object
            @change="structureSelected($event)"
            ref="structureAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('structureAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vendedor"
            :items="salesmanItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedSalesman"
            return-object
            @change="salesmanSelected($event)"
            ref="salesmanAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('salesmanAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Distribuidor"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Categoría de Cliente"
            :items="clientCategoryItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="id"
            return-object
            v-model="selectedClientCategory"
            @change="clientCategorySelected($event)"
            ref="clientCategoryAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('clientCategoryAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            disabled
            hide-details
            v-model="this.selectedClient"
            label="Cliente"
          >
            <v-icon
              slot="append-outer"
              class="enabled-icon"
              @click="clientSearchClick"
            >
              mdi-magnify
            </v-icon>
            <!-- eslint-disable -->
            <v-icon
              slot="prepend"
              :class="
                this.selectedClient
                  ? 'enabled-icon'
                  : 'disabled-icon'
              "
              @click="clientSelected(null)"
            >
              mdi-close
            </v-icon>
            <!-- eslint-enable -->
          </v-text-field>
          <v-progress-linear
            :active="downloading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
    </v-card-text>
    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="downloadShowSearch"
      :show="downloadShowSearch"
      :title="downloadSearchOptions.title"
      :endpoint="downloadSearchOptions.endpoint"
      :ordering="downloadSearchOptions.ordeting"
      :searchLabel="downloadSearchOptions.searchLabel"
      :headers="downloadSearchOptions.headers"
      :filterString="downloadSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="downloadSearchOptions.searchOnURL"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import XLSX from "xlsx";

export default {
  name: "Downloads",

  components: {
    //
    PaginatedSearchDialog
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      cropItems: [],
      salesmanItems: [],
      clientCategoryItems: [],
      dealerItems: [],
      filterStructure: null,
      filterCrop: null,
      filterSalesman: null,
      filterClientCategory: null,
      filterDealer: null,
      filterClient: null,
      selectedCampaign: [],
      selectedStructure: null,
      selectedCrop: null,
      selectedSalesman: null,
      selectedDealer: null,
      selectedClient: null,
      selectedClientCategory: null,
      downloading: false,
      downloadShowSearch: null,
      downloadSearchOptions: null,
      currentTab: 0
    };
  },

  methods: {
    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "structureAutocomplete":
          this.filterStructure = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          break;
        case "salesmanAutocomplete":
          this.filterSalesman = null;
          break;
        case "clientCategoryAutocomplete":
          this.filterClientCategory = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
    },

    structureSelected(item) {
      this.filterStructure = item;
      this.loadSalesmans();
      this.loadDealers();
    },

    cropSelected(item) {
      this.filterCrop = item;
      this.loadDealers();
    },

    salesmanSelected(item) {
      this.filterSalesman = item;
    },

    clientCategorySelected(item) {
      this.filterClientCategory = item;
    },

    dealerSelected(item) {
      this.filterDealer = item;
    },

    clientSearchClick() {
      if (!this.filterStructure) {
        this.$confirm(
          "Seleccione campaña para evaluación de 'Estructura Comercial'"
        );
        return;
      }
      this.downloadSearchOptions = {
        headers: [
          { text: "Código", value: "client_data.code", sortable: false },
          {
            text: "Identificación",
            value: "client_data.identification",
            sortable: false
          },
          { text: "Nombre", value: "client_data.name", sortable: false },
          {
            text: "Categoría",
            value: "client_data.category_object.description",
            sorteable: false
          }
        ],
        title: "Cliente...",
        endpoint:
          "/data/clients_hierarchy/" + this.filterStructure.id.toString(),
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "clientSelected",
        searchOnURL: true
      };
      this.downloadShowSearch = true;
    },

    searchCanceled() {
      this.downloadShowSearch = false;
      this.downloadSearchOptions = {};
    },

    searchSelected(data) {
      this[this.downloadSearchOptions.selected](
        data,
        this.downloadSearchOptions.row
      );
      this.searchCanceled();
    },

    async clientSelected(client) {
      if (client) {
        this.filterClient = client.client_data;
        this.selectedClient = client.client_data.name;
        this.selectedClientCategory = null;
        this.filterClientCategory = null;
      } else {
        this.filterClient = null;
        this.selectedClient = null;
      }
      await this.loadDealers();
    },

    async loadSalesmans() {
      this.salesmanItems = [];
      this.selectedSalesman = null;
      this.filterSalesman = null;
      let salesmans = null;
      if (this.filterStructure) {
        salesmans = await this.$bRoot.search(
          "/data/salesman_campaign_hierarchy",
          null,
          null,
          "campaign__id=" + this.filterStructure.id.toString()
        );
        this.salesmanItems = salesmans.data.results;
      }
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      if (this.filterStructure && this.filterClient) {
        dealers = await this.$bRoot.searchAll(
          "/data/clients_dealers_hierarchy" +
            "/" +
            this.filterStructure.id.toString() +
            "/" +
            this.filterClient.id.toString()
        );
        this.dealerItems = dealers;
      } else {
        if (this.filterStructure && this.filterCrop) {
          dealers = await this.$bRoot.search(
            "/data/dealers_campaign_crop_hierarchy" +
              "/" +
              this.filterStructure.id.toString() +
              "/" +
              this.filterCrop.id.toString(),
            null,
            null
          );
        }
        if (dealers && dealers.data) {
          this.dealerItems = dealers.data;
        }
      }
    },

    async doDownloads() {
      if (this.currentTab === 0) {
        await this.DownloadSales();
      } else if (this.currentTab === 1) {
        await this.DownloadDeliveries();
      }
    },

    async DownloadSales() {
      if (this.selectedCampaign.length === 0) {
        this.$confirm("Seleccione campaña/s");
        return;
      }
      if (!this.filterStructure) {
        this.$confirm(
          "Seleccione campaña para evaluación de 'Estructura Comercial'"
        );
        return;
      }
      try {
        let campaigns_ids = this.selectedCampaign.map(i => i.id).toString();
        this.downloading = true;
        let endPoint =
          "/data/sales_download/" +
          campaigns_ids.replaceAll(",", "-").replace(/\s+/g, "") +
          "/" +
          this.filterStructure.id.toString() +
          "/" +
          /* eslint-disable */
          (this.filterCrop ? this.filterCrop.id.toString() : "0") +
          "/" +
          /* eslint-disable */
          (this.filterSalesman ? this.filterSalesman.salesman_id.toString() : "0") +
          "/" +
          /* eslint-disable */
          (this.filterDealer ? this.filterDealer.dealer_id.toString() : "0") +
          "/" +
          /* eslint-disable */
          (this.filterClientCategory ? this.filterClientCategory.id.toString() : "0") +
          "/" +
          /* eslint-disable */
          (this.filterClient ? this.filterClient.id.toString() : "0");

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endPoint, null, null, null, null);
        if (raw.data) {
          let datosWS = XLSX.utils.json_to_sheet(raw.data);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "ventas");
          XLSX.writeFile(wb, "ventas.xlsx");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.downloading = false;
      }
    },

    async DownloadDeliveries() {
      try {
        this.downloading = true;
        let raw = await this.$bRoot.axios.get("/data/deliveries/");
        if (raw.data) {
          let datosWS = XLSX.utils.json_to_sheet(raw.data);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "entregas");
          XLSX.writeFile(wb, "entregas.xlsx");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.downloading = false;
      }
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign.push(this.campaignItems[index]);
        this.selectedStructure = this.campaignItems[index].url;
        this.filterStructure = this.campaignItems[index];
      }

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //clientCategories
      let clientCategories = await this.$bRoot.searchAll(
        "/data/categories",
        null,
        "description"
      );
      this.clientCategoryItems = clientCategories;

      //Salesmans and Dealers
      await this.loadSalesmans();
      await this.loadDealers();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.downloading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
